import { isEmpty } from "../../../../utils";

export const toErrorMessage = (error: unknown) => {
  if (!error) {
    return "";
  }

  if (typeof error === "string") {
    return error;
  }

  if (Array.isArray(error)) {
    return error.join(", ");
  }

  if (typeof error === "object" && "message" in error) {
    const message = (error as { message?: unknown }).message;
    return typeof message === "string" ? message : "";
  }

  return String(error);
};

export const getFieldError = (fieldErrors: Record<string, unknown>, fieldName: string) => {
  if (!fieldErrors || !fieldErrors[fieldName] || isEmpty(fieldErrors[fieldName])) {
    return "";
  }

  return toErrorMessage(fieldErrors[fieldName]);
};
